// CANONICAL COPY (GH #7115). src/constants/obligations/obl-equipment-siting.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-equipment-siting',
  title: 'Verify equipment siting and protection',
  description:
    'Confirm that equipment is sited and protected to reduce the risks of physical and environmental threats, unauthorised access and damage. Siting decisions shall consider line-of-sight from public areas, proximity to hazards, access restrictions to sensitive devices (printers, displays showing sensitive data, server racks) and protection of cabling and power connections. Review the equipment siting standard and physical inspections of critical equipment.',
  category: 'assets',
  scfIds: ['SCF-PHY-008'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Equipment siting standard is published' },
    { type: 'document-within-sla', description: 'Standard review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
